import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

import { ReactComponent as ArrowDown } from '../../../assets/images/arrowdown.svg';
import { ReactComponent as ArrowUp } from '../../../assets/images/arrowup.svg';
import { ReactComponent as SortIcon } from '../../../assets/images/sortby.svg';
import { useWindowSize } from '../../../hooks/useWindowResize';

import { JobsDropdownStyles, TransparentDropdownStyles } from './DropdownStyles'; // Assuming styles are extracted

import styles from './Sortby.module.scss';

const DropdownIndicator = ({ selectProps, ...restOfProps }) => (
  <components.DropdownIndicator {...restOfProps}>
    {selectProps.menuIsOpen ? <ArrowUp /> : <ArrowDown />}
  </components.DropdownIndicator>
);

const Sortby = ({ value, onChange, sortOptions, defaultValue, jobSorting }) => {
  const { t } = useTranslation('common');
  const size = useWindowSize();
  const isMobileScreen = useMemo(() => size.width <= 600, [size.width]);

  const translatedOptions = useMemo(
    () => sortOptions.map((option) => ({ ...option, label: t(option.label) })),
    [sortOptions, t]
  );

  const getPlaceholderText = (defaultSortByValue) => {
    switch (defaultSortByValue) {
      case 'jobs_created_at_desc':
        return t('sort.mostRecent');
      case 'jobs_created_at_asc':
        return t('sort.oldest');
      case 'nearest_to_farthest':
        return t('sort.nearestFirst');
      default:
        return t('sort.mostRecent');
    }
  };

  return (
    <div className={styles.cont}>
      {!jobSorting && (
        <>
          <SortIcon />
          <p className={styles.text}>{t('sort.sortBy')}</p>
        </>
      )}
      <Select
        styles={jobSorting ? JobsDropdownStyles : TransparentDropdownStyles}
        defaultValue={defaultValue}
        isClearable={false}
        isSearchable={false}
        name="sortby"
        placeholder={getPlaceholderText(defaultValue)}
        options={translatedOptions}
        isMobileScreen={isMobileScreen}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator,
        }}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Sortby;
